$(document).ready(function() {
  if (window.location.href.includes("products")) {
    document.querySelectorAll('input, button, select').forEach(elem => {
      elem.addEventListener("click", event => {
        var item = event.target.value;
        var productURL = event.target.getAttribute('producturl');
        var productURLID = productURL;
        var parent = event;
        var clickedButtonUrl = this.baseURI;
        console.log('Variante gewechselt');
        setTimeout(function() {
          $('#reload').load(" #reload");
        }, 50);
      });
    });
  }
});